import { render, staticRenderFns } from "./DisassembleScrap.vue?vue&type=template&id=0d36165a"
import script from "./DisassembleScrap.vue?vue&type=script&lang=js"
export * from "./DisassembleScrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports